import { useCallback, useState } from 'react';

type RegenerateDialogState = {
    readonly isOpen: boolean;
    readonly openAfterMenuCloses: () => void;
    readonly setIsOpen: (isOpen: boolean) => void;
};

export const useRegenerateDialogState = (): RegenerateDialogState => {
    const [isOpen, setIsOpen] = useState(false);

    const openAfterMenuCloses = useCallback((): void => {
        setTimeout(() => {
            setIsOpen(true);
        }, 0);
    }, []);

    return { isOpen, openAfterMenuCloses, setIsOpen };
};
